export default "/images/offerte-adviseur.svg?d5c2f832fe4dad7981e2320182e00efd";